import { PaperProps } from '@material-ui/core/Paper';
import { useContext, useEffect } from 'react';
import { Context } from '../UIShell/context';

export const useHeaderElevation = (elevation: PaperProps['elevation']): void => {
    const [state, { headerElevation, resetHeaderElevation }] = useContext(Context);

    const current = state.getIn(['header', 'elevation']);

    useEffect(() => {
        if (typeof elevation !== 'undefined' && elevation >= 0 && current !== elevation) {
            headerElevation(elevation);
        }

        return (): void => {
            if (typeof elevation !== 'undefined' && elevation >= 0) {
                resetHeaderElevation();
            }
        };
    }, [elevation]);
};
